// Şube Bazlı Fiyat Sistemi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.branchPrice';

export const inventoryBranchPriceGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Şube fiyatları nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Bu pencere, ürün için şubelere özel satış fiyatı tanımlamanızı ve merkezi (varsayılan) fiyattan bağımsız fiyat yönetmenizi sağlar.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Ürün ve şube fiyatları'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu ekran ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Aynı ürünü farklı şubelerde farklı fiyatla satmak için kullanılır. Her şube için ayrı satış fiyatı tanımlarsınız; ürün kartındaki varsayılan fiyat değişmez.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. "Şube Fiyatlarını Kullan" anahtarı'),
      text: t(`${G}.s2.text`, 'Üstteki kartta ürün adı, stok kodu ve varsayılan satış fiyatı görünür. Sağdaki "Şube Fiyatlarını Kullan" anahtarı hangi fiyatın uygulanacağını belirler.'),
      tips: [
        t(`${G}.s2.tip1`, 'Açıkken: satışlarda ilgili şubenin fiyatı uygulanır.'),
        t(`${G}.s2.tip2`, 'Kapalıyken: tanımlı şube fiyatı olsa bile satışlarda varsayılan ürün fiyatı kullanılır.'),
        t(`${G}.s2.tip3`, 'Anahtar değişikliği hemen kaydedilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Yeni şube fiyatı ekleyin'),
      text: t(`${G}.s3.text`, '"Yeni Ekle" düğmesine basın, şubeyi seçin ve satış fiyatını girin. Liste fiyatı ve paket fiyatı isteğe bağlıdır. Satırdaki kaydet simgesiyle ekleyin.'),
      tips: [
        t(`${G}.s3.tip1`, 'Her şube için bir fiyat satırı olur; fiyatı olan şubeler seçim listesinde görünmez.'),
        t(`${G}.s3.tip2`, 'Tüm şubelere fiyat tanımlandıysa "Yeni Ekle" düğmesi gizlenir.'),
        t(`${G}.s3.tip3`, 'Hiç şube yoksa önce şube oluşturmanız gerekir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Satırı düzenleyin veya silin'),
      text: t(`${G}.s4.text`, 'Tablodaki kalem simgesiyle satış, liste ve paket fiyatını satır üzerinde değiştirip kaydedin; çöp kutusu simgesi şube fiyatını (onay sonrası) siler.'),
      tips: [
        t(`${G}.s4.tip1`, 'Fiyat değişiklikleri kayıt altına alınır (değişiklik logu); böylece şube fiyat geçmişini takip etmek kolaylaşır.'),
        t(`${G}.s4.tip2`, 'Soluk ve italik görünen fiyat: bu satırı alış faturası açmıştır, şubeye özel satış fiyatı tanımlı değildir; ürün kartındaki fiyat gösterilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Pencereyi kapatın'),
      text: t(`${G}.s5.text`, 'Her işlem anında kaydedildiği için ayrıca kaydet düğmesi yoktur; "Kapat" ile çıkabilirsiniz. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
